// // import environment from "@/configs/environment.js";
import BaseBusinessEventRunningTotal from "@/models/BaseBusinessEventRunningTotal.js";
import deepGroupBy from "@/services/groupByUtil.js";
import _ from 'lodash';
import BaseModelUnitRunningTotal from "@/models/BaseModelUnitRunningTotal.js";
import BaseModelInformationTracking from "@/models/BaseModelInformationTracking.js";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
    name: "BusinessEventApprovalMixin",
    ...mapActions("postModule", [
        "UpdateAllItems",
        "deleteAllItem",
        "CreateAllItems",
        "UpdateItems"
    ]),
    computed: {
        ...mapGetters("getModule", ["withFilter", "getLocalInputControls"]),
        ...mapState("postModule", ["response"]),
    },
    methods: {
        async _RunningTotalEvent(transactionData, BusinessEventRunningTotal, UnitRunningTotal, InfoTracker) {
            const self = this;
            debugger;
            const getConfig1 = item => item.ProgramId;
            const getConfig2 = item => item.PartnerId;
            const getConfig3 = item => item.UnitClass;
            const getConfig4 = item => item.UnitPool;
            const getConfig5 = item => item.UnitType;
            const getConfig6 = item => item.VestingType;

            let groupByResult = deepGroupBy(
                transactionData,
                getConfig1,
                getConfig2,
                getConfig3,
                getConfig4,
                getConfig5,
                getConfig6
            );
            try {
                let RunningTotalAggregate = this.getRunningTotalAggregate(groupByResult);
                console.log("RunningTotalAggregate Data", RunningTotalAggregate)

                if (BusinessEventRunningTotal) {
                    let buzRunningTotalResponse = await this._BusinessEventRunningTotal(RunningTotalAggregate);
                    console.log("buzRunningTotalResponse", buzRunningTotalResponse)
                }

                if (UnitRunningTotal) {
                    let unitTotalResponse = await this._UnitRunningTotal(RunningTotalAggregate);
                    console.log("unitTotalResponse", unitTotalResponse)
                }
                // if (InfoTracker) {
                //     let infoTrackerResponse = await this._InformationTracker(RunningTotalAggregate);
                //     console.log("infoTrackerResponse", infoTrackerResponse)
                // }
            } catch (error) {
                console.log(error)
                throw error
            }
        },

        getRunningTotalAggregate(groupByResult) {
            let RunningTotalArray = [];
            Object.keys(groupByResult).forEach(function (programKey, programIndex) {
                let programResult = groupByResult[programKey];
                Object.keys(programResult).forEach(function (partnerKey, partnerIndex) {
                    let partnerResult = programResult[partnerKey];
                    Object.keys(partnerResult).forEach(function (unitClassKey, unitClassIndex) {
                        let unitClassResult = partnerResult[unitClassKey]
                        Object.keys(unitClassResult).forEach(function (unitPoolKey, unitPoolIndex) {
                            let unitPoolResult = unitClassResult[unitPoolKey]
                            Object.keys(unitPoolResult).forEach(function (unitTypeKey, unitTypeIndex) {
                                let unitTypeResult = unitPoolResult[unitTypeKey]
                                Object.keys(unitTypeResult).forEach(function (vestingTypeKey, vestingTypeIndex) {
                                    let vestingTypeResult = unitTypeResult[vestingTypeKey]

                                    if (vestingTypeResult && vestingTypeResult[0]) {
                                        let row = {};
                                        row.ProgramId = vestingTypeResult[0].ProgramId
                                        row.PartnerId = vestingTypeResult[0].PartnerId
                                        row.BusinessEvent = vestingTypeResult[0].BusinessEvent
                                        row.UnitClass = vestingTypeResult[0].UnitClass
                                        row.UnitPool = vestingTypeResult[0].UnitPool
                                        row.UnitType = vestingTypeResult[0].UnitType
                                        row.VestingType = vestingTypeResult[0].VestingType
                                        row.Unit = _.sumBy(vestingTypeResult, 'Unit');

                                        RunningTotalArray.push(row);
                                    }

                                });
                            });
                        });
                    });
                });
            });
            return RunningTotalArray;
        },
        async _BusinessEventRunningTotal(TransactionData) {

            const self = this;
            try {
                let BusinessEventRunningTotalUpdateItems = [];
                let BusinessEventRunningTotalCreateItems = [];
                let BusinesseventRunningTotalAPIData = self.withFilter(BaseBusinessEventRunningTotal.list);
                for (let i = 0; i < TransactionData.length; i++) {
                    if (TransactionData[i].PartnerId
                        && TransactionData[i].ProgramId
                        && TransactionData[i].UnitClass
                        && TransactionData[i].UnitPool
                        && TransactionData[i].UnitType
                        && TransactionData[i].VestingType
                        && TransactionData[i].BusinessEvent) {
                        let result = BusinesseventRunningTotalAPIData.filter(function (obj) {
                            if (obj.PartnerId
                                && obj.ProgramId
                                && obj.UnitClass
                                && obj.UnitPool
                                && obj.UnitType
                                && obj.VestingType
                                && obj.BusinessEvent) {
                                return (

                                    obj.PartnerId == TransactionData[i].PartnerId
                                    && obj.ProgramId == TransactionData[i].ProgramId
                                    && obj.UnitClass == TransactionData[i].UnitClass
                                    && obj.UnitPool == TransactionData[i].UnitPool
                                    && obj.UnitType == TransactionData[i].UnitType
                                    && obj.VestingType == TransactionData[i].VestingType
                                    && obj.BusinessEvent == TransactionData[i].BusinessEvent
                                );
                            }
                        });
                        if (result && result[0]) {
                            let updateBusinessUnitRunningTotal = {};
                            updateBusinessUnitRunningTotal.BusinessEvent = TransactionData[i].BusinessEvent;
                            updateBusinessUnitRunningTotal.PartnerId = result[0].PartnerId;
                            updateBusinessUnitRunningTotal.ProgramId = result[0].ProgramId;
                            updateBusinessUnitRunningTotal.UnitClass = result[0].UnitClass;
                            updateBusinessUnitRunningTotal.UnitPool = result[0].UnitPool;
                            updateBusinessUnitRunningTotal.UnitType = result[0].UnitType;
                            updateBusinessUnitRunningTotal.VestingType = result[0].VestingType;
                            updateBusinessUnitRunningTotal.Unit = result[0].Unit + TransactionData[i].Unit
                            updateBusinessUnitRunningTotal.Id = result[0].Id;
                            BusinessEventRunningTotalUpdateItems.push(updateBusinessUnitRunningTotal);
                        }
                        else {
                            let createBusinessUnitRunningTotal = {};
                            createBusinessUnitRunningTotal.BusinessEvent = TransactionData[i].BusinessEvent;
                            createBusinessUnitRunningTotal.PartnerId = TransactionData[i].PartnerId;
                            createBusinessUnitRunningTotal.ProgramId = TransactionData[i].ProgramId;
                            createBusinessUnitRunningTotal.UnitClass = TransactionData[i].UnitClass;
                            createBusinessUnitRunningTotal.UnitPool = TransactionData[i].UnitPool;
                            createBusinessUnitRunningTotal.UnitType = TransactionData[i].UnitType;
                            createBusinessUnitRunningTotal.VestingType = TransactionData[i].VestingType;
                            createBusinessUnitRunningTotal.Unit = TransactionData[i].Unit;
                            BusinessEventRunningTotalCreateItems.push(createBusinessUnitRunningTotal);

                        }
                    }
                }
                let createdobject = {
                    BusinessEventRunningTotal: {
                        config: BaseBusinessEventRunningTotal,
                        createData: BusinessEventRunningTotalCreateItems,
                        processInBatches: true
                    }
                };

                let updateobject = {
                    BusinessEventRunningTotal: {
                        config: BaseBusinessEventRunningTotal,
                        updateData: BusinessEventRunningTotalUpdateItems,
                        processInBatches: true
                    }
                };
                console.log("Bsuiness Event Running Total")
                console.log("createdobject", createdobject)
                console.log("updateobject", updateobject)

                let createResponse = null
                let updateResponse = null

                if (BusinessEventRunningTotalCreateItems.length > 0) {
                    createResponse = await self.CreateAllItems(createdobject)
                    console.log("BusinessUnitRunningTotal created ", createResponse);
                }
                if (BusinessEventRunningTotalUpdateItems.length > 0) {
                    updateResponse = await self.UpdateAllItems(updateobject);
                    console.log("BusinessUnitRunningTotal Updated ", updateResponse);
                }
                return "success"
            }
            catch (err) {
                console.log(err);
                throw err;
            }

        },
        async _UnitRunningTotal(TransactionData) {
            const self = this;
            try {
                let UnitRunningTotalUpdateItems = [];
                let UnitRunningTotalCreateItems = [];
                let UnitRunningTotalAPIData = self.withFilter(BaseModelUnitRunningTotal.list);
                for (let i = 0; i < TransactionData.length; i++) {
                    if (TransactionData[i].PartnerId
                        && TransactionData[i].ProgramId
                        && TransactionData[i].UnitClass
                        && TransactionData[i].UnitPool
                        && TransactionData[i].UnitType
                        && TransactionData[i].VestingType
                        && TransactionData[i].BusinessEvent) {
                        let result = UnitRunningTotalAPIData.filter(function (obj) {
                            if (obj.PartnerId && obj.ProgramId && obj.UnitClass && obj.UnitPool && obj.UnitType && obj.VestingType) {
                                return (
                                    obj.PartnerId == TransactionData[i].PartnerId
                                    && obj.ProgramId == TransactionData[i].ProgramId
                                    && obj.UnitClass == TransactionData[i].UnitClass
                                    && obj.UnitPool == TransactionData[i].UnitPool
                                    && obj.UnitType == TransactionData[i].UnitType
                                    && obj.VestingType == TransactionData[i].VestingType
                                );
                            }
                        });
                        if (result && result[0]) {
                            let updateUnitRunningTotal = {};
                            updateUnitRunningTotal.PartnerId = result[0].PartnerId;
                            updateUnitRunningTotal.ProgramId = result[0].ProgramId;
                            updateUnitRunningTotal.UnitClass = result[0].UnitClass;
                            updateUnitRunningTotal.UnitPool = result[0].UnitPool;
                            updateUnitRunningTotal.UnitType = result[0].UnitType;
                            updateUnitRunningTotal.VestingType = result[0].VestingType;
                            updateUnitRunningTotal.Unit = result[0].Unit + TransactionData[i].Unit
                            updateUnitRunningTotal.Id = result[0].Id;
                            UnitRunningTotalUpdateItems.push(updateUnitRunningTotal);
                        }
                        else {
                            let createUnitRunningTotal = {};
                            createUnitRunningTotal.PartnerId = TransactionData[i].PartnerId;
                            createUnitRunningTotal.ProgramId = TransactionData[i].ProgramId;
                            createUnitRunningTotal.UnitClass = TransactionData[i].UnitClass;
                            createUnitRunningTotal.UnitPool = TransactionData[i].UnitPool;
                            createUnitRunningTotal.UnitType = TransactionData[i].UnitType;
                            createUnitRunningTotal.VestingType = TransactionData[i].VestingType;
                            createUnitRunningTotal.Unit = TransactionData[i].Unit
                            UnitRunningTotalCreateItems.push(createUnitRunningTotal);

                        }
                    }
                }
                let createdobject = {
                    UnitRunningTotal: {
                        config: BaseModelUnitRunningTotal,
                        createData: UnitRunningTotalCreateItems,
                        processInBatches: true
                    }
                };
                let updateobject = {
                    UnitRunningTotal: {
                        config: BaseModelUnitRunningTotal,
                        updateData: UnitRunningTotalUpdateItems,
                        processInBatches: true
                    }
                };
                console.log("Unit Event Running Total")
                console.log("createdobject", createdobject)
                console.log("updateobject", updateobject)

                let createResponse = null
                let updateResponse = null

                if (UnitRunningTotalCreateItems.length > 0) {
                    createResponse = await self.CreateAllItems(createdobject);
                    console.log("UnitRunningTotal Created", createResponse)
                }
                if (UnitRunningTotalUpdateItems.length > 0) {
                    updateResponse = await self.UpdateAllItems(updateobject);
                    console.log("UnitRunningTotal updated", updateResponse)
                }
                return "success"
            }
            catch (err) {
                console.log(err);
                throw err;
            }

        },

        async _InformationTracker(InputData) {
            const self = this;
            try {

                let InformationTrackingCreateItems = [];
                let InformationTrackingAPIData = self.withFilter(BaseModelInformationTracking.list);
                let TransactionData = _.uniqBy(InputData, v => [v.ProgramId, v.PartnerId].join());
                for (let i = 0; i < TransactionData.length; i++) {
                    if (TransactionData[i].PartnerId
                        && TransactionData[i].ProgramId
                    ) {
                        let result = InformationTrackingAPIData.filter(function (obj) {
                            if (obj.PartnerId
                                && obj.ProgramId
                            ) {
                                return (
                                    obj.PartnerId == TransactionData[i].PartnerId
                                    && obj.ProgramId == TransactionData[i].ProgramId
                                );
                            }
                        });
                        if (result && result.length <= 0) {
                            let createInformationTracker = {};
                            createInformationTracker.PartnerId = TransactionData[i].PartnerId;
                            createInformationTracker.ProgramId = TransactionData[i].ProgramId;
                            createInformationTracker.SignaturePage = "Not Received";
                            createInformationTracker.Receive83b = "Not Received";
                            createInformationTracker.Receive83bFiledWithIRS = "Not Received";
                            createInformationTracker.Status = "Pending";

                            InformationTrackingCreateItems.push(createInformationTracker);

                        }
                    }
                }
                let createdobject = {
                    InformationTracker: {
                        config: BaseModelInformationTracking,
                        createData: InformationTrackingCreateItems,
                        processInBatches: true
                    }
                };
                console.log("Information Tracker Object", createdobject)

                if (InformationTrackingCreateItems.length > 0) {
                    let createResponse = await self.CreateAllItems(createdobject)
                    console.log("Information tracker created", createResponse);
                }
                return "Success"

            } catch (error) {
                console.log("error")
                throw err;
            }
        }
    }

}